import { render } from "./Chosen.vue?vue&type=template&id=44967a46&scoped=true"
import script from "./Chosen.vue?vue&type=script&lang=js"
export * from "./Chosen.vue?vue&type=script&lang=js"

import "./Chosen.vue?vue&type=style&index=0&id=44967a46&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44967a46"]])

export default __exports__